import { Wrench, Car, Truck, Zap, CheckCircle, Recycle, Package, Settings } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { Link } from "react-router-dom";
import { services } from "../data/mock";

const iconMap = {
  Wrench: Wrench,
  Car: Car,
  Truck: Truck,
  Zap: Zap,
  Recycle: Recycle,
  Package: Package,
  Settings: Settings
};

export const Services = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-slate-600 font-semibold uppercase tracking-wider text-sm">
            Car Recovery Services Hackney
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mt-3 mb-4">
            Complete Vehicle Transport Solutions in East London
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Professional car recovery and transport services across Hackney and 20-mile radius. Fast response, competitive prices, available 24/7
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="border-2 border-slate-100 hover:border-slate-300 hover:shadow-xl transition-all duration-300 group"
              >
                <CardContent className="p-8">
                  <div className="flex flex-col gap-4">
                    <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                      <IconComponent className="w-7 h-7 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-slate-900 mb-3">
                        {service.title}
                      </h3>
                      <p className="text-slate-600 mb-4 leading-relaxed text-sm">
                        {service.description}
                      </p>
                      <ul className="space-y-2">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center gap-2 text-slate-700 text-sm">
                            <CheckCircle className="w-4 h-4 text-green-600 flex-shrink-0" />
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                      {service.link && (
                        <Link 
                          to={service.link}
                          className="mt-4 inline-block text-slate-900 font-semibold hover:text-slate-600 transition-colors text-sm"
                        >
                          Learn More →
                        </Link>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
